import React from 'react';
import { HeroSectionV5 } from '../components/HeroSectionV5';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ContentBreakdown } from '../components/ContentBreakdown';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { BonusSection } from '../components/BonusSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { ImpactPhrases } from '../components/ImpactPhrases';
import { Footer } from '../components/Footer';
export function SalesPageV5() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900" data-id="element-776">
      <HeroSectionV5 data-id="element-777" />
      <PainSection data-id="element-778" />
      <TruthSection data-id="element-779" />
      <ProductPresentation data-id="element-780" />
      <ContentBreakdown data-id="element-781" />
      <BenefitsSection data-id="element-782" />
      <TestimonialsSection data-id="element-783" />
      <ForYouSection data-id="element-784" />
      <GuaranteeSection data-id="element-785" />
      <BonusSection data-id="element-786" />
      <ValueStack basePrice={19999} popupStrikethroughPrice="$38.997 ARS" popupSpecialPrice="$29.498 ARS" showFlashBonus={false} data-id="element-787" />
      <FAQSection data-id="element-788" />
      <ImpactPhrases data-id="element-789" />
      <Footer data-id="element-790" />
    </div>;
}